import { css } from '@emotion/react';
export const refinementTagStyles = css`
  > span {
    margin: ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}
      ${"var(--ds-space-025, 2px)"} 0px;

    > span {
      max-width: var(--content-width);
    }
  }
`;